/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';

import { HvmiBanner, SmHotelGalleryTitle, MerchBanner } from '@marriott/mi-shop-components';
import { HotelInformationComponent } from '@marriott/mi-shop-components';

import { HeadingComponent } from '@marriott/mi-shop-components';
import { SearchForm } from '@marriott/mi-shop-components';
import { SearchResultsComponent } from '@marriott/mi-shop-components';
import { HotelOverviewComponent } from '@marriott/mi-shop-components';
import { HotelGalleryPhotoViewerComponent } from '@marriott/mi-shop-components';
import { AdobeClientDataLayer } from '@marriott/mi-shop-components';
import { HeroBannerAEM } from '@marriott/mi-shop-components';
import { AEMText } from '@marriott/mi-shop-components';
import {
  StaticWrapper,
  Footer,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
} from '@marriott/mi-common-static-components';
import { MerchandisingSmallBannerComp, MerchandisingSerpBannerNonEditable } from '@marriott/mi-merch-components';
import { PropertyBarWrapper } from '@marriott/mi-homepage-components';

MapTo(`mi-aem-homepage-spa/components/content/propertybar`)(props => (
  <PropertyBarWrapper {...props} locale={pageProps.currentLocale} />
));

MapTo(`mi-aem-shop-spa/components/content/hotelgallerytitle`)(SmHotelGalleryTitle, {
  emptyLabel: 'SmHotelGalleryTitle',
  isEmpty: false,
});

MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
  props => <MerchandisingSmallBannerComp {...props} {...props.model} />,
  {
    emptyLabel: 'MerchandesingSmallBanner',
    isEmpty: false,
  }
);

MapTo(`mi-aem-common-spa/components/content/serpbanner`)(
  props => <MerchandisingSerpBannerNonEditable {...props} {...props.model} />,
  {
    emptyLabel: 'MerchandisingSerpBanner',
    isEmpty: false,
  }
);

MapTo(`mi-aem-shop-spa/components/content/hotelinformation`)(HotelInformationComponent, {
  emptyLabel: 'HotelInformationComponent',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/foundation/staticwrapper`)(StaticWrapper, {
  emptyLabel: 'StaticWrapper',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/headingcomponent`)(HeadingComponent, {
  emptyLabel: 'HeadingComponent',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform/v1/searchform`)(SearchForm, {
  emptyLabel: 'SearchForm',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults/v1/searchresults`)(SearchResultsComponent, {
  emptyLabel: 'SearchResultsComponent',
  isEmpty: false,
});
MapTo(`mi-aem-shop-spa/components/content/hotelgalleryoverview`)(HotelOverviewComponent, {
  emptyLabel: 'HotelOverviewComponent',
  isEmpty: false,
});
MapTo(`mi-aem-shop-spa/components/content/hotelgalleryphotoviewer`)(HotelGalleryPhotoViewerComponent, {
  emptyLabel: 'HotelGalleryPhotoViewerComponent',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/adobeclientdatalayer`)(AdobeClientDataLayer, {
  emptyLabel: 'AdobeClientDataLayer',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner/v1/herobanner`)(HeroBannerAEM, {
  emptyLabel: 'HeroBanner',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/text`)(AEMText, { emptyLabel: 'Text', isEmpty: false });
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hvmibanner/v1/hvmibanner`)(HvmiBanner, {
  emptyLabel: 'HvmiBanner',
  isEmpty: false,
});
MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/merchbanner/v1/merchbanner`)(MerchBanner, {
  emptyLabel: 'MerchBanner',
  isEmpty: false,
});
MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(Footer, {
  emptyLabel: 'Footer',
  isEmpty: false,
});
MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => <NavigationContainerWrapper {...props} />, {
  emptyLabel: 'NavigationContainerWrapper',
  isEmpty: false,
});
MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
  emptyLabel: 'NavigationUtilityLinkWrapper',
  isEmpty: false,
});
MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
  emptyLabel: 'NavigationWrapper',
  isEmpty: false,
});
